import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnDragSlideToggleModule } from '@lib/form/drag-slide-toggle';
import { SnFormInputModule } from '@lib/form/input';
import { GoogleMapModule } from '@lib/geo/google/map';
import { SnMapModule } from '@lib/geo/map';
import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnTooltipModule } from '@lib/ui/tooltip';

import { ApplianceCameraStatusComponent } from './components/appliance-camera-status';
import { ApplianceCapacityIndicatorComponent } from './components/appliance-capacity-indicator/appliance-capacity-indicator';
import { ApplianceCapacityStatusComponent } from './components/appliance-capacity-status';
import { ApplianceDashboardCamerasComponent } from './components/appliance-dashboard-cameras';
import { ApplianceDashboardCapacityComponent } from './components/appliance-dashboard-capacity/appliance-dashboard-capacity.component';
import { ApplianceDashboardDetailsComponent } from './components/appliance-dashboard-details/appliance-dashboard-details.component';
import { ApplianceDashboardHeaderComponent } from './components/appliance-dashboard-header/appliance-dashboard-header.component';
import { ApplianceDashboardLocationMapComponent } from './components/appliance-dashboard-location-map/appliance-dashboard-location-map.component';
import { ApplianceDashboardWarningBannerComponent } from './components/appliance-dashboard-warning-banner/appliance-dashboard-warning-banner.component';
import { ApplianceEventTableComponent } from './components/appliance-event-table/appliance-event-table.component';
import { ApplianceFormDrawerComponent } from './components/appliance-form-drawer/appliance-form-drawer.component';
import { ApplianceMapMaximizerDialogComponent } from './components/appliance-map-maximizer-dialog/appliance-map-maximizer-dialog.component';
import { ApplianceNetworkReloadComponent } from './components/appliance-network-reload/appliance-network-reload';
import { ApplianceStatusComponent } from './components/appliance-status';
import { ApplianceTableComponent } from './components/appliance-table';
import { AppliancesChargerControlComponent } from './components/appliances-charger-control/appliances-charger-control.component';
import { CompassDeviceManagementTableComponent } from './components/compass-device-management-table';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatSortModule,
    MatTableModule,
    MatChipsModule,
    MatCardModule,
    MatDividerModule,
    MatRippleModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    // Libs
    NgxLoadingButtonsModule,
    SnCommonModule,
    SnFormModule,
    SnTooltipModule,
    SnActionsModule,
    SnListModule,
    SnDragSlideToggleModule,
    SnIconModule,
    GoogleMapModule,
    SnMapModule,
    MatButtonModule,
    SnDataListModule,
    MatDialogModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatSelectModule,
    SnButtonModule,
    SnFormInputModule,
    SnDrawerModule,
    TranslationModule,
  ],
  exports: [
    ApplianceEventTableComponent,
    ApplianceTableComponent,
    ApplianceStatusComponent,
    ApplianceCapacityStatusComponent,
    AppliancesChargerControlComponent,
    CompassDeviceManagementTableComponent,
    ApplianceDashboardWarningBannerComponent,
    ApplianceDashboardHeaderComponent,
    ApplianceDashboardLocationMapComponent,
    ApplianceDashboardDetailsComponent,
    ApplianceDashboardCapacityComponent,
    ApplianceDashboardCamerasComponent,
    ApplianceCapacityIndicatorComponent,
    ApplianceMapMaximizerDialogComponent,
    ApplianceCameraStatusComponent,
    ApplianceNetworkReloadComponent,
    ApplianceFormDrawerComponent,
  ],
  declarations: [
    ApplianceTableComponent,
    ApplianceStatusComponent,
    ApplianceCapacityStatusComponent,
    ApplianceEventTableComponent,
    AppliancesChargerControlComponent,
    CompassDeviceManagementTableComponent,
    ApplianceDashboardWarningBannerComponent,
    ApplianceDashboardHeaderComponent,
    ApplianceDashboardLocationMapComponent,
    ApplianceDashboardDetailsComponent,
    ApplianceDashboardCapacityComponent,
    ApplianceDashboardCamerasComponent,
    ApplianceCapacityIndicatorComponent,
    ApplianceMapMaximizerDialogComponent,
    ApplianceCameraStatusComponent,
    ApplianceNetworkReloadComponent,
    ApplianceFormDrawerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SnAppliancesModule {}
